import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'fr8bot-ui-dropdown-content',
  imports: [],
  templateUrl: './dropdown-content.component.html',
  styleUrl: './dropdown-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownContentUIComponent {}
